import { ReactNode } from 'react'
import { BagIcon } from '~/components/icons/generated/BagIcon'
import { CoordinateIcon } from '~/components/icons/generated/CoordinateIcon'
import { FavoriteIcon } from '~/components/icons/generated/FavoriteIcon'

type IconType = 'COORDINATE' | 'FOLDER' | 'ITEM'

type Props = {
  type: IconType
  className?: string
  children?: ReactNode
}

const icon = {
  COORDINATE: <CoordinateIcon height={48} />,
  FOLDER: <FavoriteIcon height={48} />,
  ITEM: <BagIcon height={48} />,
} as const

export const NoResults: React.FC<Props> = ({
  type,
  className = '',
  children,
}) => {
  return (
    <div
      className={`flex flex-col items-center gap-y-[9px] text-[46px] ${className} text-gray-500`}
    >
      {icon[type]}
      <p className="text-center text-[16px] font-bold leading-[1.4] xl:text-[18px] xl:leading-[1.4]">
        {children}
      </p>
    </div>
  )
}
